import menuService from '@/services/menu';

const setMenu = (menu) => {
  menu.forEach(item => {
    if (!item.redirect) {
      delete item.redirect;
    } else {
      delete item.page;
      delete item.mode;
    }

    if (!item.children || !item.children.length) {
      delete item.children;
    } else {
      delete item.page;
      delete item.mode;

      item.children.forEach(children => {
        if (!children.redirect) {
          delete children.redirect;
        } else {
          delete children.page;
          delete children.mode;
        }

        if (!children.children || !children.children.length) {
          delete children.children;
        } else {
          delete children.page;
          delete children.mode;

          children.children.forEach(lastChildren => {
            delete lastChildren.children;

            if (!lastChildren.redirect) {
              delete lastChildren.redirect;
            } else {
              delete lastChildren.page;
              delete lastChildren.mode;
            }
          });
        }
      });
    }
  });

  return menu;
};

export default {
  setCurrentPage: ({ commit }, payload) => commit('setCurrentPage', payload),

  setCurrentActiveMenu: ({ commit }, payload) => commit('setCurrentActiveMenu', payload),

  getMenu: async ({ commit }, moduleId) => {
    try {
      const { data } = await menuService.getMenu(moduleId);

      if (data) {
        commit('setMenu', setMenu(data));
      }
    } catch (err) {
      console.error(err);
    }
  },

  getSuspendedMenu: async ({ commit }, params) => {
    try {
      const { data } = await menuService.getSuspendedMenu(params);

      if (data) {
        commit('setSuspendedMenu', setMenu(data));
      }
    } catch (err) {
      console.error(err);
    }
  }
};
